import {
  CognitoUser,
  CognitoUserPool,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js'

import { closeWebSocket } from './websocket.service.js'

const poolConfig = {
  UserPoolId: import.meta.env.VITE_COGNITO_USERPOOL_ID,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
}

const UserPool = new CognitoUserPool(poolConfig)

function authenticateUser() {
  return new Promise((resolve, reject) => {
    const user = UserPool.getCurrentUser()
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          reject(err)
        }
        if (session) {
          document.cookie = `cognito=${session.accessToken.jwtToken}`
          user.getUserAttributes((attrErr, attributes) => {
            if (attrErr || !attributes) {
              reject(attrErr)
            }
            else {
              const userAttributes = getUserFromCognitoAttributes(attributes)
              resolve(userAttributes)
            }
          })
        }
      })
    }
    else {
      reject()
    }
  })
}

function getUserFromCognitoAttributes(attributes) {
  const user = {}
  attributes.forEach((attr) => {
    if (attr.Name !== 'email_verified') {
      user[attr.Name] = attr.Value
    }
  })
  return user
}

function logoutUser() {
  closeWebSocket()
  return new Promise((resolve, reject) => {
    const user = UserPool.getCurrentUser()
    if (user) {
      document.cookie = 'cognito=; max-age=0'
      resolve(user.signOut())
    }
    else {
      reject()
    }
  })
}

function signInUser(email, password) {
  const user = new CognitoUser({
    Username: email,
    Pool: UserPool,
  })

  const authDetails = new AuthenticationDetails({
    Username: email,
    Password: password,
  })

  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        document.cookie = `cognito=${session.accessToken.jwtToken}`
        if (session) {
          document.cookie = `cognito=${session.accessToken.jwtToken}`
          user.getUserAttributes((attrErr, attributes) => {
            if (attrErr || !attributes) {
              reject(attrErr)
            }
            else {
              const userAttributes = getUserFromCognitoAttributes(attributes)
              resolve(userAttributes)
            }
          })
        }
      },
      onFailure: (data) => {
        reject(data)
      },
    })
  })
}

function getCurrentCognitoUser() {
  return UserPool.getCurrentUser()
}

function isAuthenticated() {
  const user = getCurrentCognitoUser()

  if (!user) {
    return false
  }
  const tokenKey = `CognitoIdentityServiceProvider.${UserPool.getClientId()}.${user.getUsername()}.accessToken`
  const tokenData = localStorage.getItem(tokenKey)

  if (!tokenData) {
    return false
  }
  return true
}

function getAccessToken() {
  return new Promise((resolve, reject) => {
    const user = UserPool.getCurrentUser()

    if (!user) {
      return reject()
    }

    user.getSession((err, session) => {
      if (err || !session) {
        return reject()
      }

      return resolve(session.getAccessToken().getJwtToken())
    })
  })
}

function forgotPasswordRequest(userEmail) {
  return new Promise((resolve, reject) => {
    const userData = {
      Username: userEmail,
      Pool: UserPool,
    }
    const cognitoUser = new CognitoUser(userData)

    cognitoUser.forgotPassword({
      onSuccess: function (data) {
        console.log('Code delivery data:', data)
        resolve()
      },
      onFailure: function (err) {
        console.error('Forgot password request failed:', err)
        reject(err)
      },
    })
  })
}

function setNewPasswordByEmail(userEmail, tempPassword, newPassword) {
  return new Promise((resolve, reject) => {
    const userData = {
      Username: userEmail,
      Pool: UserPool,
    }
    const cognitoUser = new CognitoUser(userData)

    const authenticationDetails = new AuthenticationDetails({
      Username: userEmail,
      Password: tempPassword,
    })

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        resolve(result)
      },
      onFailure: (err) => {
        reject(err)
      },
      newPasswordRequired: () => {
        cognitoUser.completeNewPasswordChallenge(newPassword, {}, {
          onSuccess: (result) => {
            console.log('Wachtwoord succesvol gewijzigd!')
            resolve(result)
          },
          onFailure: (err) => {
            reject(err)
          },
        })
      },
    })
  })
}

function forgotPasswordConfirmByEmail(userEmail, verificationCode, newPassword) {
  return new Promise((resolve, reject) => {
    const userData = {
      Username: userEmail,
      Pool: UserPool,
    }
    const cognitoUser = new CognitoUser(userData)

    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess: function () {
        console.log('Password successfully reset.')
        resolve()
      },
      onFailure: function (err) {
        console.error('Password confirmation failed:', err)
        reject(err)
      },
    })
  })
}

export {
  authenticateUser,
  signInUser,
  logoutUser,
  getAccessToken,
  forgotPasswordRequest,
  forgotPasswordConfirmByEmail,
  setNewPasswordByEmail,
  isAuthenticated,
  getCurrentCognitoUser,
}
